import React from "react";
import TextFieldWithStyle from "../../HOCs/InputWithStyle/InputWithStyle";
import { useForm, Controller } from "react-hook-form";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import NumberFormat from "react-number-format";

export default function ScheduleForm({ data, onSubmit, isLoading }) {
	const { handleSubmit, control } = useForm();
	const { schedule = {} } = data;

	function localOnSubmit(data) {
		const formattedData = Object.entries(data).reduce((acc, curr) => {
			const [key, val] = curr;
			const [day, type] = key.split(" ");
			return {
				...acc,
				[day]: {
					...acc[day],
					[type]: val,
				},
			};
		}, {});
		onSubmit({
			schedule: formattedData,
		});
	}
	const days = {
		monday: "Lunes",
		tuesday: "Martes",
		wednesday: "Miercoles",
		thursday: "Jueves",
		friday: "Viernes",
		saturday: "Sabado",
		sunday: "Domingo",
	};

	const daysInOrder = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

	function limit(val, max) {
		if (val.length === 1 && val[0] > max[0]) {
			val = "0" + val;
		}

		if (val.length === 2) {
			if (Number(val) === 0) {
				val = "00";

				//this can happen when user paste number
			} else if (val > max) {
				val = max;
			}
		}

		return val;
	}

	function maxHours(val) {
		const hour = limit(val.substring(0, 2), "23");
		const min = limit(val.substring(2, 4), "59");
		return `${hour}:${min}`;
	}

	const scheduleMap = Object.entries(schedule)
		.sort((a, b) => {
			const aDayIndex = daysInOrder.indexOf(daysInOrder.find((day) => day === a[0]));
			const bDayIndex = daysInOrder.indexOf(daysInOrder.find((day) => day === b[0]));
			return aDayIndex - bDayIndex;
		})
		.map(([key, val], index) => {
			return (
				<div key={key}>
					<Controller
						control={control}
						style={{ maxWidth: "150px" }}
						margin="normal"
						required
						id={key}
						label={days[key] + " Abre"}
						name={key + " opening"}
						autoFocus
						defaultValue={val?.opening}
						as={<NumberFormat format={maxHours} customInput={TextFieldWithStyle} />}
					/>
					<Controller
						control={control}
						style={{ maxWidth: "150px", marginLeft: "1em" }}
						margin="normal"
						required
						id={key}
						label={days[key] + " Cierra"}
						name={key + " closing"}
						autoFocus
						defaultValue={val?.closing}
						as={<NumberFormat format={maxHours} customInput={TextFieldWithStyle} />}
					/>
				</div>
			);
		});
	return (
		<form onSubmit={handleSubmit(localOnSubmit)}>
			{scheduleMap}
			<ButtonWithStyle type="submit" disabled={isLoading}>
				Guardar
			</ButtonWithStyle>
		</form>
	);
}
